import {SSAI_RELATED_SAMPLE_MARKER} from '../core/ssai/ssaiUtils';
import type {AdSample} from '../types/AdSample';
import type {Sample} from '../types/Sample';

import {getGlobalLocationPathname} from './globalScopeUtils';
import {isValidString} from './stringUtils';
import * as Utils from './Utils';
import {isNullish, removeTrailingSlash} from './Utils';

/**
 * Clear all "state" values from the sample (all values that describe "playing sample", "startup sample" ...).
 */
export function clearSampleStateValues(sample: Sample): void {
  sample.ad = 0;
  sample.adId = undefined;
  sample.adIndex = undefined;
  sample.adPosition = undefined;
  sample.adSystem = undefined;
  sample.autoplay = undefined;
  sample.buffered = 0;
  sample.castTech = undefined;
  sample.completed = undefined;
  sample.drmLoadTime = undefined;
  sample.droppedFrames = 0;
  sample.duration = 0;
  sample.errorCode = undefined;
  sample.errorData = undefined;
  sample.errorMessage = undefined;
  sample.errorSegments = undefined;
  sample.errorSeverity = undefined;
  sample.isProgramChange = undefined;
  sample.pageLoadTime = 0;
  sample.paused = 0;
  sample.played = 0;
  sample.playerStartupTime = 0;
  sample.seeked = 0;
  sample.startupTime = 0;
  sample.state = undefined;
  sample.videoStartFailed = undefined;
  sample.videoStartFailedReason = undefined;
  sample.videoStartupTime = 0;

  sample[SSAI_RELATED_SAMPLE_MARKER] = undefined;
}

export function getDefaultSamplePath(): string | undefined {
  const pathname = getGlobalLocationPathname();
  return isValidString(pathname) ? removeTrailingSlash(pathname) : undefined;
}

export function buildAdSample(sample?: Sample): AdSample {
  const adSample: AdSample = {};

  if (isNullish(sample)) {
    return adSample;
  }

  adSample.cdnProvider = sample.cdnProvider;
  adSample.customUserId = sample.customUserId;
  adSample.domain = sample.domain;
  adSample.key = sample.key;
  adSample.language = sample.language;
  adSample.path = sample.path;
  adSample.player = sample.player;
  adSample.playerKey = sample.playerKey;
  adSample.playerTech = sample.playerTech;
  adSample.screenHeight = sample.screenHeight;
  adSample.screenWidth = sample.screenWidth;
  adSample.size = sample.size;
  adSample.userAgent = sample.userAgent;
  adSample.userId = sample.userId;
  adSample.version = sample.version;
  adSample.videoId = sample.videoId;
  adSample.videoImpressionId = sample.impressionId;
  adSample.videoTitle = sample.videoTitle;
  adSample.videoWindowHeight = sample.videoWindowHeight;
  adSample.videoWindowWidth = sample.videoWindowWidth;

  Utils.transferCustomDataFields(sample, adSample);
  adSample.experimentName = sample.experimentName;

  return adSample;
}
